import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://expense-tracker-json-server.herokuapp.com",
});

export default axiosInstance;
